import React from 'react';
import { Box, Button, Chip, Grid, Stack, Typography } from '@mui/material';

import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import { useNavigate } from 'react-router';

const PremiumPage = ({ title = '', subTitle = '', image }) => {
    const navigate = useNavigate();
    return (
        <Box sx={{ padding: { sx: 3, md: 5 } }}>
            <Grid container rowSpacing={3} columnSpacing={{ xs: 3, md: 8 }}>
                <Grid item sx={12} sm={7.25}>
                    <Stack gap={3} alignItems="flex-start">
                        <Chip
                            label="Premium"
                            icon={<DiamondOutlinedIcon />}
                            sx={{
                                background: 'rgba(0, 33, 77, 0.20)',
                                color: '#00214D',
                                display: 'inline-flex',

                                '.MuiSvgIcon-root': {
                                    width: '18px',
                                    height: '18px',
                                    path: {
                                        fill: '#00214D'
                                    }
                                }
                            }}
                        />
                        <Typography variant="h2" color="#212121">
                            {title}
                        </Typography>
                        <Typography component="p" variant="subtitle2" fontSize="1rem" color="#676767">
                            {subTitle}
                        </Typography>
                        <Button
                            size="large"
                            className="alternate"
                            variant="contained"
                            sx={{ minWidth: 157, borderRadius: '12px !important' }}
                            onClick={() => navigate('/dashboard/update-plan')}
                        >
                            Upgrade
                        </Button>
                    </Stack>
                </Grid>
                <Grid item sx={12} sm={4.75}>
                    <img src={image} alt="freemium-register" />
                </Grid>
            </Grid>
        </Box>
    );
};

export default PremiumPage;
